import CryptoJs from 'crypto-js'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'


/*** 加密*/
export function encrypt(word) {
    let key = CryptoJs.enc.Utf8.parse(systemConfig.cryptoKey);
    let srcs = CryptoJs.enc.Utf8.parse(word);
    let encrypted = CryptoJs.AES.encrypt(srcs, key, {mode: CryptoJs.mode.ECB, padding: CryptoJs.pad.Pkcs7});
    return encrypted.toString();
}
/*** 解密*/
export function decrypt(word) {
    let key = CryptoJs.enc.Utf8.parse(systemConfig.cryptoKey);
    let decrypt = CryptoJs.AES.decrypt(word, key, {mode: CryptoJs.mode.ECB, padding: CryptoJs.pad.Pkcs7});
    return CryptoJs.enc.Utf8.stringify(decrypt).toString();
}

